import { useBoxLead } from "@modules/boxLead/hooks/useBoxLeadDetails"
import { word } from "@modules/core/utils/i18n"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { MenuItem } from "primereact/menuitem"
import { TabMenu } from "primereact/tabmenu"
import { useTransition } from "react"

type BoxLeadTabProps = {
  leadId: string
  activeIndex: number
  className?: string
} & React.ComponentProps<"div">

export function BoxLeadTab({ leadId, activeIndex, className, ...props }: BoxLeadTabProps) {
  const defaultClassName = "flex w-full mt-3"
  const { data: leadDetails } = useBoxLead(leadId)
  const { setCurrentStackState } = useSidebar()
  const [, startTransition] = useTransition()

  const items: MenuItem[] = [
    { label: word("box.lead.detailsInfo.tab.overview") },
    { label: word("box.member.detailsInfo.profile"), visible: leadDetails.user?.id ? true : false },
    { label: word("box.member.detailsInfo.offers"), visible: leadDetails.user?.id ? true : false },
  ]

  const onTabChange = (e: { index: number }) => {
    startTransition(() => {
      setCurrentStackState("activeTabIndex", e.index)
    })
  }

  return (
    <div className={className ?? defaultClassName} {...props}>
      <TabMenu model={items} activeIndex={activeIndex} onTabChange={onTabChange} className="w-full" />
    </div>
  )
}
